module.exports = globalConf;


//////////////////
// WEBPACK FOOTER
// external "globalConf"
// module id = 30
// module chunks = 2